import { Badge } from "@/client/components/shad/badge";

export const UserRoleBadge = ({ role }: { role: string }) => {
  if (role === "ADMIN") {
    return (
      <Badge className="bg-purple-50 text-purple-700 dark:bg-purple-950 dark:text-purple-300">
        Admin
      </Badge>
    );
  }

  return (
    <Badge className="bg-sky-50 text-sky-700 dark:bg-sky-950 dark:text-sky-300">
      User
    </Badge>
  );
};
